import { DealerID } from "./Dealer";
import { DealerLocationID } from "./DealerLocation";
import { DMS_CAPABILITIES, DMSIDS } from "./Dms";

export type DMSWarningID = number;

export enum DMS_WARNING_SERVERITIES {
  Log = 1,
  Warning = 2,
  Error = 3,
  Critical = 4
}

export enum DMS_WARNING_SOURCES {
  Client = 1,
  Server = 2,
  CustomQuery = 3
}

export interface DMSWarning {
  created_on: string;
  id: DMSWarningID; // The unique identifier of the DMS warning
  dealer_id: DealerID | null; // The dealer this warning belongs to
  dealer_location_id: DealerLocationID | null; // The dealer location this warning belongs to
  dms_id: DMSIDS; // The DMS that generated this warning
  severity: DMS_WARNING_SERVERITIES; // The severity level of the warning
  source: DMS_WARNING_SOURCES; // The source of the warning
  dms_capability_id: DMS_CAPABILITIES | null; // The DMS capability that triggered this warning
  message: string; // The warning message
  dealer_name?: string; // The name of the dealer
  location_name?: string; // The name of the dealer location
}
